module.exports = [() => (totalSeconds) => {
  const minutes = parseInt(totalSeconds / 60) % 60;
  const seconds = totalSeconds % 60;

  if (seconds < 10 && seconds >= 0) {
    return `${minutes}:0${seconds}`;
  }
  return `${minutes}:${seconds}`;
}];



// WEBPACK FOOTER //
// ./main/filters/timer-format-filter.js